<template>
    <nav class="kleptos-start-menu">
        <div class="kleptos-start-menu-title"></div>
        <ul>
            <li class="has-dropdown">
                <button><i class="fa fa-briefcase"></i> Programs</button>
                <ul>
                    <li><button>Accessories</button></li>
                    <li><button>ICU</button></li>
                    <li class="has-dropdown"><button>Pulse</button>
                        <ul>
                            <li><button>Something</button></li>
                            <li><button>Something</button></li>
                        </ul>
                    </li>
                    <li><button>Elusion Browser</button></li>
                </ul>
            </li>
            <li><button><i class="fa fa-folder-open"></i> Documents</button></li>
            <li><button><i class="fa fa-cog"></i> Settings</button></li>
            <li><button><i class="fa fa-search"></i> Find</button></li>
            <li><button><i class="fa fa-question-circle"></i> Help</button></li>
            <li><button><i class="fa fa-file-code-o"></i> Run</button></li>
            <li><button><i class="fa fa-eject"></i>Shut Down</button></li>
        </ul>
    </nav>
</template>

<script>
    // import SystemTray from './SystemTray';

    export default {
        components: {
            // kleptosSystemTray: SystemTray,
        },
        data () {
            return {
                // startMenuOpen: true,
            }
        },
        computed: {

        }
    }
</script>

<style lang="scss" scoped>

    //------------------------------------------------------
    // START MENU
    //------------------------------------------------------

    .kleptos-start-menu {
        position: absolute;
        left: 0;
        bottom: 100%; //44px; // taskbar height
        width: 266px;
        border-left: 38px solid darken(#bbbaac, 4%); // color strip
        // border-top: 20px solid #c7c6b7;
        // border-bottom: 1px solid lighten(#a5a293, 5%); //rgba(red, 0.2);
        box-shadow: 0 3px 8px 2px rgba(black, 0.2);
        z-index: -1;
    }

    //------------------------------------------------------
    // UL LI
    //------------------------------------------------------

   .kleptos-start-menu ul {
        list-style: none;
        padding: 0;
        margin: 0;
        background: #c7c6b7; // variable?

        li {
            position: relative;
        }
    }

    .kleptos-start-menu > ul {
        padding: rem-calc(20 0);
    }

    // Bottom divider
    .kleptos-start-menu > ul > li:last-child {
        border-top: 1px solid rgba(white, 0.2);
        box-shadow: 0 -1px 0px 0 rgba(#b9b6a4, 1);
    }

    //------------------------------------------------------
    // BUTTONS
    //------------------------------------------------------

    .kleptos-start-menu button {
        display: flex;
        align-items: center;
        width: 100%;
        padding: rem-calc(13 30);
        border: 0;
        background: none;
        color: #343434; // make variable

        i {
            margin-right: rem-calc(16);
        }

        &:hover {
            background: #364847;
            color: white;
        }
    }

    // CARET
    .kleptos-start-menu ul li.has-dropdown > button:after {
        position: relative;
        // left: 15px;
        left: 10px;
        content: "\f0da";
        margin-left: auto;
        font-family: "FontAwesome";
        font-size: rem-calc(18);
    }

    //------------------------------------------------------
    // NESTED MENUS
    //------------------------------------------------------

    .kleptos-start-menu {
        ul ul {
            display: none;
            position: absolute;
            top: -3px;
            left: calc(100% - 5px);
            min-width: 210px;
            box-shadow: 0 3px 8px 2px rgba(black, 0.2);
            z-index: 1;

            button {
                font-size: rem-calc(15); // keep?
                padding: rem-calc(10 30); // keep?
            }
        }
    }

    .kleptos-start-menu li.has-dropdown:hover > ul {
        display: block;
    }

    //------------------------------------------------------
    // VERTICAL MENU TITLE
    //------------------------------------------------------

    .kleptos-start-menu-title {
        position: absolute;
        left: -27px;
        bottom: 10px;
        width: 19px;
        height: 153px;
        background: url(~@/assets/img/taskbar-title-99@2x.png) no-repeat;
        background-size: contain;
    }

</style>